import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import AheadBusinessClientNav from "@/components/layout/AheadBusinessClientNav.vue"
import PeraltaClientNav from "@/components/layout/PeraltaClientNav.vue"
import { useAccountContext } from "@/hooks/useAccountContext"
import { ProductSlugEnum } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientNav',
  setup(__props) {

const { clientProduct } = useAccountContext()

const isAheadClient = ref(clientProduct === ProductSlugEnum.AheadBusiness)
const isPeraltaClient = ref(clientProduct === ProductSlugEnum.Peralta)

return { __sfc: true,clientProduct, isAheadClient, isPeraltaClient, AheadBusinessClientNav, PeraltaClientNav }
}

})